import { StyledHubspotDynamicFormIframeComponent } from "./hubspot-dynamic-form-iframe-component.scss";
import ContactSalesHubspotFormComponent from "../side-by-side-hubspot-form/components/contact-sales-hubspot-form-component";

const HubspotDynamicFormIframeComponent = (props) => {
  const { formId, source, withPrivacyNotice, formMinHeight } = props;

  return (
    <StyledHubspotDynamicFormIframeComponent className="hubspot-dynamic-form-iframe-component">
      <ContactSalesHubspotFormComponent
        formId={formId}
        formMinHeight={formMinHeight}
        source={source}
        withPrivacyNotice={withPrivacyNotice}
      />
    </StyledHubspotDynamicFormIframeComponent>
  );
};

export default HubspotDynamicFormIframeComponent;
